module.exports = __webpack_public_path__ + "media/cellsim_notification_sound.dceeb380.wav";